export const noop = () => null;

/** Match media helper - mockup for window.matchMedia */
export function matchMedia(matchesVal = true) {
  return function matchMediaInner(query) {
    return {
      query,
      matches: matchesVal,
      addListener: noop,
      removeListener: noop,
    };
  };
}
